import React, {FunctionComponent} from "react";
import {Box, Divider, Link, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import {SUPPORT_EMAIL} from "./support-note";

const LEGAL_LINKS = ['imprint', 'terms', 'privacy', 'security'] as const;

export const AppFooter: FunctionComponent = () => {
    const {t} = useTranslation();
    return (
        <Box component="footer" data-testid="app-footer" sx={{mt: 'auto', pt: 4, pb: 2, px: 2}}>
            <Divider sx={{mb: 2}}/>
            <Stack component="nav" aria-label={t('footer.ariaLabel')} direction="row" flexWrap="wrap"
                   justifyContent="center" columnGap={2} rowGap={0.5}>
                {LEGAL_LINKS.map(key => (
                    <Link key={key} href={t(`footer.${key}.url`)} target="_blank" rel="noreferrer"
                          variant="caption" color="textSecondary" underline="hover">
                        {t(`footer.${key}.label`)}
                    </Link>
                ))}
                <Link href={`mailto:${SUPPORT_EMAIL}`} variant="caption" color="textSecondary" underline="hover">
                    {t('footer.contact.label', {email: SUPPORT_EMAIL})}
                </Link>
            </Stack>
        </Box>
    );
};
